import { render, staticRenderFns } from "./hion_globo.vue?vue&type=template&id=765e2888&"
import script from "./hion_globo.vue?vue&type=script&lang=js&"
export * from "./hion_globo.vue?vue&type=script&lang=js&"
import style0 from "./hion_globo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports